import rsvpModelReducer from '../../../pages/guestlists/helpers/rsvp-model-reducer';

export default class RsvpsStatusEmailHelper {

    constructor($injector) {
        this.injector = $injector;
        this.resourceSelect = this.injector.get('ResourceSelect');
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');
    }

    /**
     *
     * @param rsvp
     * @param contact
     * @param guestlist
     * @returns Promise
     */
    startFlow(rsvp, contact, guestlist) {
        return new Promise((resolve, reject) => {
            this.resourceSelect.selectStatus(rsvp.status).then((response) => {
                let preselectedRsvpStatus = rsvp.status;
                let selectedRsvpStatus = response.selectedStatus;

                return this.api.put(`rsvps/${rsvp.id}`, {
                    ...rsvpModelReducer(rsvp, guestlist),
                    status: selectedRsvpStatus
                }).then(() => {
                    this.alert.success(
                        this._getTranslationValue('status_updated.title'),
                        this._getTranslationValue('status_updated.content')
                    );

                    if (selectedRsvpStatus === preselectedRsvpStatus
                        || !this.existEmailTemplateForStatus(guestlist, selectedRsvpStatus)) {
                        resolve();
                        return;
                    }

                    this.alert.animatedAlert(
                        this._getTranslationValue('ask-email-pop-up.title'),
                        this._getTranslationValue('ask-email-pop-up.content', {
                            email_status: this.formatEmailType(selectedRsvpStatus),
                            contact_full_name: contact.full_name,
                            contact_email: contact.preferred_email
                        }),
                        'attention',
                        {
                            confirmButtonText: this._getTranslationValue('ask-email-pop-up.confirm'),
                            cancelButtonText: this._getTranslationValue('ask-email-pop-up.cancel')
                        }
                    ).then(
                        () => {
                            return this.api.post(`messages`, this.setupMessage(rsvp, contact, this.getStatusTemplateIdForGuestlist(guestlist, selectedRsvpStatus), selectedRsvpStatus))
                                .then(
                                    () => {
                                        this.alert.success(
                                            this._getTranslationValue('message_sent.title'),
                                            this._getTranslationValue('message_sent.content')
                                        );
                                        resolve();
                                    },
                                    response => {
                                        this.alert.handle(response);
                                        resolve();
                                    }
                                );
                        },
                        () => {
                            resolve();
                        })
                }, () => {
                    this.alert.error(
                        this._getTranslationValue('status_updated_failed.title'),
                        this._getTranslationValue('status_updated_failed.content')
                    );
                    reject();
                });
            }, () => {
                resolve();
            });
        });
    }

    _getTranslationValue(path, params) {
        return this.translate.instant(`rsvps.helpers.rsvps-status-email-helper.${path}`, params);
    }


    existEmailTemplateForStatus(guestlist, status) {
        return !_.isNull(this.getStatusTemplateIdForGuestlist(guestlist, status));
    }

    getStatusTemplateIdForGuestlist(guestlist, status) {
        const filteredGuestlistTemplates = _.filter(guestlist.templates, template => (template.status === status));

        if (filteredGuestlistTemplates.length > 0) {
            return _.get(_.first(filteredGuestlistTemplates), 'template_id', null);
        }

        return null;
    }

    formatEmailType(status) {
        let formattedEmailType = status.substring(0, status.length - 2) + 'ation';

        if (status === 'waitlisted' || status === 'requested') {
            formattedEmailType = status.substring(0, status.length - 2);
        } else if (status === 'declined') {
            formattedEmailType = 'decline';
        }

        return formattedEmailType.charAt(0).toUpperCase() + formattedEmailType.slice(1);
    }

    setupMessage(rsvp, contact, templateId, status) {
        return {
            type: 'email',
            send_to_override: contact.preferred_email,
            recipient_type: 'rsvp',
            rsvps: {
                filters: [
                    {
                        field: 'id',
                        operator: 'IN',
                        value: [rsvp.id]
                    }
                ],
                count: 1
            },
            templates: {
                filters: [
                    {
                        field: 'id',
                        operator: 'IN',
                        value: [templateId]
                    }
                ],
                count: 1
            },
            attach_ticket: false,
            attach_passbook: false,
            attach_files: true,
            attach_invoice: false
        };
    }
}

angular.module('festzelt-os.modules.rsvps')
    .service('RsvpsStatusEmailHelper', [
        '$injector',
        ($injector) => new RsvpsStatusEmailHelper($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/rsvps/helpers/status-email-helper.js